import {
  getCurrentDateTime,
  getDatePart,
  getOneMonthInPast,
  getSameDateLastYear,
} from "../../components/helpers/datetime";
import BaseReducer from "./BaseReducer";

class CustomerReducer extends BaseReducer {
  domain = "CustomerInteraction";
  type = "Admin";

  initialState = {
    activeTab: 1,
    showFilters: false,
    totalRecords: 0,
    recordsReturned: 0,
    pageNumber: 1,
    pageSize: 50,
    sites: [],
    customers: [],
    selectedSites: [],
    selectedCustomer: null,
    selectedCustomers: [],
    onlyBannedCustomers: false,
    interactionDateFrom: getDatePart(getOneMonthInPast(), "YYYY-MM-DD"),
    interactionDateTo: getDatePart(getCurrentDateTime(), "YYYY-MM-DD"),
    interactionDateRange: "",
    records: [],
    recordsOnlyVulnerableCustomer: {
      data: [],
      totalRecords: 0,
      recordsReturned: 0,
      pageNumber: 0,
    },
    recordsOnlyTemporaryBreakCustomer: {
      data: [],
      totalRecords: 0,
      recordsReturned: 0,
      pageNumber: 0,
    },
    recordsOnlyBannedCustomer: {
      data: [],
      totalRecords: 0,
      recordsReturned: 0,
      pageNumber: 0,
    },
    recordsForDiaryTab: [],
    diaryEntries: [],
    selectedDate: getCurrentDateTime(),
    selectedDiaryEntry: null,
    reviewStatusIds: [3, 4],
    searchText: "",
    reviewStatusCounts: [
      {
        color: "blue",
        disabled: false,
        key: 1,
        text: "Completed",
        quantity: 1,
      },
      {
        color: "red",
        disabled: false,
        key: 2,
        text: "Overdue",
        quantity: 1,
      },
      {
        color: "green",
        disabled: false,
        key: 3,
        text: "Due",
        quantity: 4,
      },
      {
        color: "orange",
        disabled: false,
        key: 4,
        text: "Not Due",
        quantity: 1,
      },
      {
        color: "grey",
        disabled: false,
        key: -1,
        text: "No Review",
        quantity: 1,
      },
    ],
    diaryCarouselId: "diary",
    returnDateFrom: getSameDateLastYear(),
    returnDateTo: getCurrentDateTime(),
    updatedSortColumn: {
      name: "reviewStatus",
      sortDirection: 1,
      label: "Review Status",
    },
    sortColumns: [
      { name: "reviewStatus", sortDirection: 1, label: "Review Status" },
      { name: "id", sortDirection: 1, label: "ID" },
      { name: "customer", sortDirection: 1, label: "Customer" },
      { name: "customerState", sortDirection: 1, label: "Customer State" },
      { name: "riskScore", sortDirection: 1, label: "Risk Score" },
      {
        name: "interactionCount",
        sortDirection: 1,
        label: "Interaction Count",
      },
      { name: "linkedSessions", sortDirection: 1, label: "Linked Sessions" },
      { name: "interactionDate", sortDirection: 1, label: "Interaction Date" },
    ],
  };
}

const reducer = new CustomerReducer();

export default reducer;
